import { memo } from 'react'
import AddIcon from '@mui/icons-material/Add'
import { useNavigate } from 'react-router-dom'
import MenuIcon from '@mui/icons-material/Menu'
import MenuOpenIcon from '@mui/icons-material/MenuOpen'
import { useAuth } from '../../../hooks/useAuth'
import { useCore } from "../../../hooks/useCore"
import LogoutIcon from '@mui/icons-material/Logout'
import { AppBar, Grid, IconButton, Toolbar, Tooltip, Typography } from "@mui/material"
import { drawerWidth } from '../SideBar'

function NavBar(): JSX.Element {
  const { Logout } = useAuth()
  const navigate = useNavigate()
  const { titleBar, pathTitleBar, pathData, mobileOpen, setMobileOpen, sidebarCollapsed, setSidebarCollapsed } = useCore()
  const sidebarToggleLabel = sidebarCollapsed ? 'Expandir menu' : 'Recolher menu'

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  }

  async function handleLogout() {
    await Logout()
    navigate('/')
  }

  return (
    <AppBar
      position="fixed"
      sx={{
        width: { sm: sidebarCollapsed ? '100%' : `calc(100% - ${drawerWidth}px)` },
        ml: { sm: sidebarCollapsed ? 0 : `${drawerWidth}px` },
      }}
    >
      <Toolbar>
        <Grid container alignItems="center" wrap="nowrap">
          <Grid item>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: 'none' } }}
            >
              <MenuIcon />
            </IconButton>
            <Tooltip title={sidebarToggleLabel}>
              <IconButton
                color="inherit"
                aria-label={sidebarToggleLabel}
                edge="start"
                onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                sx={{ mr: 2, display: { xs: 'none', sm: 'inline-flex' } }}
              >
                {sidebarCollapsed ? <MenuIcon /> : <MenuOpenIcon />}
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs>
            <Typography variant="h6" noWrap component="div" sx={{ mt: .5 }}>
              {titleBar}
              {
                pathTitleBar
                  ? <IconButton
                    color="inherit"
                    aria-label="add"
                    edge="start"
                    sx={{ ml: 5 }}
                    onClick={
                      () => {
                        navigate(
                          `${pathTitleBar}`,
                          { state: pathData }
                        )
                      }
                    }
                  >
                    <AddIcon />
                  </IconButton>
                  : <></>
              }
            </Typography>
          </Grid>
          <Grid item>
            <IconButton
              color="inherit"
              aria-label="logout"
              edge="start"
              onClick={handleLogout}
              sx={{ ml: 5 }}
            >
              <LogoutIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  )
}

export default memo(NavBar)